import React, { useEffect, useState } from 'react';

import type { CompanyInfoDTO } from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';

import Card from '../../../components/common/Card';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompanyInfoTable from '../../../components/tables/CompanyInfoTable';
import { useCompanyInfoApi } from '../../../hooks/useCompanyInfoApi';

const CompanyInfoList: React.FC = () => {
  const [data, setData] = useState<CompanyInfoDTO[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const { search } = useCompanyInfoApi();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Company Info', href: '/admin/companyinfo' },
  ];

  const fetchCompanyInfos = async (
    page: number,
    size: number,
  ): Promise<void> => {
    try {
      setIsLoading(true);
      const response = await search({
        page,
        pageSize: size,
        sortBy: 'Name',
        sortDescending: false,
        filters: {},
      });
      if (response && response.success && response.success) {
        setData((response.data?.results as CompanyInfoDTO[]) || []);
        setTotalRecords(response.data?.totalCount || 0);
        setTotalPages(Math.ceil((response.data?.totalCount || 0) / size));
      }
    } catch (error) {
      console.error('Error fetching company info:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyInfos(currentPage, pageSize);
  }, [currentPage, pageSize]);

  return (
    <AdminLayout
      activeMenuItem="Company Info"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
    >
      <Card
        title="Manage Company Info"
        subtitle={`Total Records: ${totalRecords}`}
      >
        <CompanyInfoTable
          services={data}
          handleEdit={(dto) => navigate(`/admin/companyinfo/${dto.id}`)}
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          isLoading={isLoading}
        />
      </Card>
    </AdminLayout>
  );
};

export default CompanyInfoList;
